'use strict';

var SystemStatusFlightSentDirective = function SystemStatusFlightSentDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-flight-sent.html'),
    controller: 'SystemStatusFlightSentController',
    link: function link(scope, element) {
      var modalElement = element.find('#system-status-flight-sent-modal');
      function showModal(event, data) {
        scope.modalData = data.entityData;
        modalElement.modal('show');
        scope.$broadcast('statusMessage:show');
      }
      scope.$on('grid:icon-click', showModal);
    }
  };
};
SystemStatusFlightSentDirective.$inject = [];
module.exports = SystemStatusFlightSentDirective;